<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'user',
})
</script>
<template>
    <a-card>
      <template #title>
        <div class="flex align-center">
          <span class="text-bold margin-right"><TeamOutlined class="text-lg" /> 用户管理</span>
          <a-tabs class="text-left flex1 margin-left" v-model:activeKey="usertype" @change="usertypeChange">
            <a-tab-pane :tab="it.text" v-for="it in usertypes" :key="it.data"></a-tab-pane>
          </a-tabs>
        </div>
      </template>
      <template #extra>
          <a-button class="margin-right" v-if="auth.creating > 0" type="primary"  @click="addNew"><PlusOutlined /> 新建用户</a-button>
      </template>
    <lanseedFormOnly :mode="false" :data="search" :rules="searchRules"  @change="searchChange"></lanseedFormOnly>
    <a-table rowKey="ID" :columns="columns" :dataSource="dataSource" :loading="loading"
        @change="onPageChange" :pagination="pagination">
      <template #bodyCell="{column,record,index}">
          <template v-if="column.key=='userid'">
           <div class="flex align-center">
            <a-avatar :size="64" :src="addip(record.pic)"></a-avatar>
            <div class="margin-lr">
              <div>姓名：<span class="text-primary">{{ record.username }}</span></div>
              <div>帐号：<span class="text-primary">{{ record.userid }}</span></div>
              <div>电话：<span class="text-primary">{{ record.tel }}</span></div>
            </div>
            </div>
          </template>
        <template v-if="column.key=='enable'">
          <a-switch @click="setEnable($event, record, index)"  checked-children="正常" un-checked-children="已禁用" :disabled="auth.edit == 0" :checked="record.enable > 0" />
        </template>
        <template v-if="column.key=='action'">
          <a-button-group>
              <a-button  type="primary" @click="() => { user = record; showdetail = true }"><SolutionOutlined /> 详情</a-button>
              <a-button danger type="primary" @click="resetPassword(record)"> <RedoOutlined /> 重置密码</a-button>
          </a-button-group>
        </template>
      </template>
    </a-table>


    <a-drawer title="用户信息" v-model:open="showdetail" width="40%">
      <user-detail :id="user.ID" v-if="showdetail"></user-detail>
    </a-drawer>

    <lanseed-form title="新增用户" v-model:open="showAdd" :data="user" :rules="rules" @change="submit">
    </lanseed-form>
  </a-card>
</template>


<script setup lang="ts" name="user">
import LanseedForm from '@/components/lanseed/form.vue'
import userDetail from './UserDetail.vue'
import {message,Modal } from 'ant-design-vue'
import { reactive,ref,onMounted } from 'vue'
import api from '@/utils/http/service'
import {addip} from '@/utils/util'
import lanseedFormOnly from '@/components/lanseed/formonly.vue'
import {EditOutlined,RedoOutlined,SolutionOutlined,TeamOutlined,PlusOutlined} from '@ant-design/icons-vue'
const advanced=ref<Boolean>(false)
const showdetail=ref<Boolean>(false)
const showAdd=ref<Boolean>(false)
const loading=ref<Boolean>(false)
let usertypes=reactive<Array>([])
let usertype=ref<String>('')
let auth=reactive<Object>(api.auth())
const columns=reactive<Array>([
  {
    title: '用户',
    dataIndex: 'userid', key:'userid'
  },
  {
    title: '状态',
    dataIndex: 'enable', key:'enable'
  },
  {
    title: '注册时间',
    dataIndex: 'regtime',
  },
  {title:'操作',key:'action',fixed:'right',align:'right'},
])
let dataSource=ref<Array>([])
let selectedRows=reactive<Array>([])
let pagination=reactive<Object>({
        current: 1,
        pageSize: 10,
        total: 0
      })
let search=reactive<Object>({})
let user=reactive<Object>({})
let rules=reactive<Object>({
        userid: { required: true,  name: '帐号',  check: r => { if (r.length < 6) { throw('用户名长度至少6位'); return false } } },
        password: { required: true, domtype: 'password', name: '密码',  check: r => { if (r.length < 6) { throw ('密码长度至少6位'); return false } } },
        username: { required: true, name: '昵称'},
        tel: { required: true, name: '电话'},
        enable: { required: true, name: '启用',domtype:'switch'},
      })
let searchRules=reactive<Object>({
  keyword:{name:'关键字'}
})
      onMounted(()=>{
        getUsertype()
      })
const  resetList= ()=> {
      pagination.current = 1
      getData()
    }
 const  onPageChange =({current, pageSize})=> {
      pagination.current = current
      pagination.pageSize = pageSize
      getData()
    }
 const  getData= ()=> {
    loading.value=true
      api.user.list({ pageSize: pagination.pageSize, pageIndex: pagination.current, usertype: usertype.value, ...search }).then(res => {
        loading.value=false
        if (res.state == 1) {
          dataSource.value = res.data.data
          pagination.current = res.data.pageIndex
          pagination.pageSize = res.data.pageSize
          pagination.total = res.data.records
        }
      })
    }
 const  setEnable= (e:Event, item:Object, index:Number)=> {
      let id = item.ID
      api.user.enable({ id: id }).then(res => {
        if (res.state == 1) {
          dataSource.value[index]['enable']=res.data
        }
      })
    }
const searchChange=(e:Object)=>{
  search=e
  resetList()
}
const  resetPassword =(user:Object) =>{
      Modal .confirm({
        title: '您确定要重置密码吗？',
        content: '密码将重置为:123456,重置后，请通知该用户尽快修改新密码',
        onOk () {
          api.user.resetpassword(user.ID).then(res => {
            if (res.state == 1) {
              message.success(res.message)
            }
          })
        }
      })
    }
const   getUsertype= ()=> {
      api.role.list({ pageFlag: false }).then(res => {
        if (res.state == 1 && res.data.length > 0) {
          usertype.value = res.data[0].roletype
          usertypes = res.data
          getData()
        }
      })
    }
const edit=(item:Object,index:Number)=>{
  user=item
  showAdd.value=true
  resetList()
}
const   usertypeChange= (e:String)=> {
      resetList()
    }
const  submit= (e:Object)=> {
      api.user.adduser(e).then(res => {
        if (res.state == 1) {
          message.success(res.message)
          showAdd.value = false
          user = null
          if (e.ID == 0) {
            dataSource.value.push(res.data)
          }
          } else {
            message.error(res.message)
          }
      })
    }

const    remove= () =>{
      dataSource.value = dataSource.value.filter(item => this.selectedRows.findIndex(row => row.key === item.key) === -1)
      selectedRows = []
    }

const  addNew= () =>{
      user = { ID: 0, userid: '', password: '',enable:true, usertype: usertype.value, username: '', tel: '',  }
      showAdd.value = true
    }
</script>
